export function isBase64 (str) {
  return typeof str === 'string' && str.includes(';base64,') && str.includes('data:')
}
